// extracted by mini-css-extract-plugin
export default {"market-indicators":"finance_market-indicators_x","clearfix":"finance_market-indicators_clearfix"};